<template>
	<div class="bigPlay" v-if="bigPlayShow">
		<div class="rankTitle">
   			<i @click="back"><img src="../assets/images/goback_1.png"/></i>
   			<h2>{{songName}}</h2>
   		</div>
   		<div class="hand" :class="{'hand2':imgPause}"></div>
   		<div class="singerImg" :class="{'imgPause':imgPause,'imgStart':!imgPause}"><img :src="bigImgUrl" alt=""/></div>
   		<div class="lrcBox">
   			<div class="lrc-content" :style="{'margin-top':lrcOffset+'px'}">
	          <p v-for="(item,index) in mysongLrc"
	             :class="{'isCurrentLrc':item.seconds>=mycurrentTime,'disCurrentLrc':item.seconds<mycurrentTime}">
	            {{item.lrcContent}}</p>
	        </div>
   		</div>
   		<div class="rangeBox">
   			<div class="currentTime">{{mycurrentTime | formatTime}}</div>
   			<input class="playRange" type="range" min="0" :max="timeLength" v-model="mycurrentTime" step="1" @change="rangeChange($event)" ref="myAudio"/>
   			<div class="allTime">{{timeLength | formatTime}}</div>
   		</div>
   		<div class="ct">
   			<div class="prev" @click="prevSong"></div>
   			<div class="play" @click="playorp" :class="{'pause':isplay}"></div>
   			<div class="next" @click="nextSong"></div>
   		</div>
   		<div class="blackBox"></div>
   		<div class="bigImg bigImgDown" :style="{'background-image':'url('+bigImgUrl+')'}"></div>
   		<div class="bigImg" :style="{'background-image':'url('+bigImgUrl+')'}"></div>
	</div>
</template>

<script>
  import jq from '../assets/jquery-1.7.2.min.js'
  import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
		tgNum:true,
		
      }
    },
    computed: {
    	...mapGetters(['bigPlayShow','songName','bigImgUrl','timeLength','mycurrentTime','songLrc','iscurrent','isplay','songList','imgPause']),
		mysongLrc(){
        if (this.songLrc) {
					var temp = this.songLrc.split('\r\n');
          temp = temp.splice(0, temp.length - 1);
          temp = temp.map((value)=> {
            var time = value.substr(1, 5);
            var seconds = parseInt(time.split(':')[0]) * 60 + parseInt(time.split(':')[1]);
            var lrcContent = value.substr(10);
            return {
              seconds,
              lrcContent
            }
					})
					temp = temp.slice(10, temp.length)
					console.log(temp, 'temp')
          return temp;
        }
      },
      lrcOffset(){
        if (this.mysongLrc) {
          var offset = (this.mysongLrc.length - document.querySelectorAll('.isCurrentLrc').length - 2) * (-28);
          return this.mycurrentTime + offset - this.mycurrentTime;
        }
      }
    },
    filters:{
    	formatTime:function(value){
    		value=Math.floor(value);
    		var fen=Math.floor(value/60);
    		var miao=value%60;
    		if(miao>=10){
    			return '0'+fen+':'+miao;
    		}else{
    			return '0'+fen+':'+'0'+miao;
    		}
    		
    	}
    },
    mounted:function(){
    	
    },
    methods: {
    	back(){
    		this.$store.commit('bigPlayShow',false);
    	},
    	rangeChange(event){
    		var newTime=this.$refs.myAudio.value;
			document.getElementById('audioPlay').currentTime=newTime;
    	},
    	playorp:function(){
	      	this.$store.commit('isplayFlag',!this.isplay);
			if (this.isplay) {
	          document.getElementById('audioPlay').play();
	          this.$store.commit('imgPause',false);
	        } else {
	          document.getElementById('audioPlay').pause();
	          this.$store.commit('imgPause',true);
	        }
	      },
      nextSong:function(){
      	if(this.iscurrent<this.songList.length-1){
      		this.$store.commit('setIscurrent',this.iscurrent+1);
      	}else{
      		this.$store.commit('setIscurrent',0);
      	}
      	this.$store.dispatch('playSong');
      	this.$store.commit('imgPause',false);
      },
      prevSong:function(){
      	if(this.iscurrent>1){
      		this.$store.commit('setIscurrent',this.iscurrent-1);
      	}else{
      		this.$store.commit('setIscurrent',this.songList.length-1);    		
      	}
      	this.$store.dispatch('playSong');
      	this.$store.commit('imgPause',false);
      },
    },
  }
</script>

<style scoped>
.bigPlay{width: 100%;height: 100%;position: fixed;left:0;top:0;z-index: 12;background: url(../../dist/bg01.jpg);background-size: 15%;}
.bigImg{width: 100%;height: 100%;position: absolute;left:0;top:0;background-size: cover;background-position: center;filter: blur(10px);z-index: -2;}
.bigImgDown{filter: none;z-index: -3;}
.blackBox{background: rgba(0,0,0,0.7);width: 100%;height: 100%;position: absolute;top:0;left:0;z-index: -1;}
.singerImg{box-shadow: 0px 0px 8px rgba(0,0,0,0.2);width: 40vh; height: 40vh; background:url(../assets/images/disc-ip6.png);background-size:100%;margin: 19vh auto 20px;border-radius: 50%;overflow: hidden;position: relative;}
@keyframes zhuan{
	0%{transform:rotate(0deg);}
	100%{transform:rotate(360deg);}
}
.imgStart{animation:zhuan 20s linear infinite running;-webkit-animation:zhuan 20s linear infinite running;}
.imgPause{animation:zhuan 20s linear infinite paused;-webkit-animation:zhuan 20s linear infinite paused;}
/*.singerImg:before{content: "";display: block;box-shadow: 0px 0px 6px rgba(0,0,0,0.8) inset;width: 4vh;height: 4vh;border-radius: 50%;background: #555;position: absolute;top:50%;left:50%;margin-left: -2vh;margin-top: -2vh;}*/
.singerImg img{border: 4px solid rgba(0,0,0,0.5);width: 66%;border-radius: 50%;position: absolute;left:50%;top:50%;margin-left: -33%;margin-top: -33%;box-sizing: border-box;}
.lrcBox{width: 100%;height: 84px;overflow: hidden;text-align: center;color: #fff;font-size: 13px;line-height: 28px;padding: 0 10px;box-sizing: border-box;}
.lrcBox .lrc-content{transition: all 0.5s;}
.lrcBox .lrc-content p{}
.rangeBox{width:100%;height:40px;padding: 10px 20px;box-sizing: border-box;color: #fff;text-align: center;}
.rangeBox .currentTime{float: left;}
.rangeBox .allTime{float: right;}
.rangeBox .playRange{width: 70%;transform: translateY(-3px);height: 3px;}
.ct{width: 70%;height:100px;margin: 0 auto;position: relative;margin-top: 5vh;}
.ct .prev{width: 6vh;height: 6vh;background: url(../../dist/next.png) no-repeat;background-size: 100%;float: left;transform: rotate(180deg);}
.ct .play{width: 8vh;height: 8vh;background: url(../../dist/play.png) no-repeat;background-size: 70%;background-position:center;position: absolute;left:50%;top:-6px;margin-left: -4vh;border: 2px solid #fff;box-sizing: border-box;border-radius: 50%;}
.ct .next{width: 6vh;height: 6vh;background: url(../../dist/next.png) no-repeat;background-size: 100%;float: right;}
.ct .pause{background: url(../../dist/pause.png) no-repeat;background-size: 70%;background-position:center;}
.hand{transition:all 0.5s;background: url(../assets/images/needle-ip6.png) no-repeat;width: 70%;height: 30%;position: absolute;right: -30%;top:9%;z-index: 1;background-size: 32%;transform: rotate(18deg);transform-origin:5% 0%;}
.hand2{transform: rotate(-2deg);}
input[type=range] {
    -webkit-appearance: none;
    background: #ccc;
    height: 3px;
    border-radius: 10px;
}
input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	background: #fff;
}
input[type=range]:focus {
    outline: none;
}    
</style>


// WEBPACK FOOTER //
// bigPlay.vue?50dd8428